module.exports = __webpack_public_path__ + "static/media/chambre-communiquant.142c4779.svg";